import React, { useMemo, useState } from "react";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import ThreeDotsMenu from "components/ThreeDotsMenu";
import DefaultThreeDotsMenuItem from "components/ThreeDotsMenu/Components/DefaultThreeDotsMenuItem";
import { ColorMapType, POINT_COLORS } from "rs-components/Spaceviewer/utils";
import { renderNumberValue } from "utils/string";
import ChevronDownIcon from "icons/rs_chevron_down.svg";
import * as styles from "./styles.module.scss";
const ColorMap = ({ range, points, colorMapLabel, colorMapType, isResultElement, onMenuItemClick, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const pointColorsReversed = [...POINT_COLORS].reverse();
    const menu = useMemo(() => [
        {
            type: "Low",
            text: "Lowest value is best",
            onClick: () => onMenuItemClick(ColorMapType.Low, pointColorsReversed),
        },
        {
            type: "Middle",
            text: "Middle value is best",
            onClick: () => onMenuItemClick(ColorMapType.Middle, [...POINT_COLORS, ...pointColorsReversed]),
        },
        {
            type: "High",
            text: "Highest value is best",
            onClick: () => onMenuItemClick(ColorMapType.High, POINT_COLORS),
        },
    ], [onMenuItemClick, pointColorsReversed]);
    const typeLabel = useMemo(() => menu.find((el) => el.type === colorMapType)?.text, [colorMapType, menu]);
    return (React.createElement("div", { className: styles["color-map"] },
        React.createElement("div", { className: styles.map },
            React.createElement("div", { className: styles.colorMapMenu },
                React.createElement(TextTruncate, { className: styles.title, text: colorMapLabel }),
                isResultElement && (React.createElement(ThreeDotsMenu, { isOpen: isOpen, icon: React.createElement(ChevronDownIcon, { className: classNames(styles.chevron, { [styles.open]: isOpen }) }), setIsOpen: setIsOpen, classes: { className: styles.threeDotsMenu }, items: menu.map((item) => {
                        return (React.createElement(DefaultThreeDotsMenuItem, { key: item.text, classes: {
                                className: classNames({
                                    [styles.activeItem]: item.type === colorMapType,
                                }),
                            }, ...item }));
                    }) }))),
            React.createElement("ul", { className: styles.list }, points.map((color, index) => (React.createElement("li", { key: `${color} +${index}`, className: styles.item, style: { backgroundColor: color } },
                React.createElement(TextTruncate, { title: typeLabel, className: styles.title }))))),
            React.createElement("div", { className: styles.limits },
                React.createElement("p", { className: styles.min }, range[0] !== range[1] && renderNumberValue(range[0])),
                React.createElement("p", { className: styles.max }, renderNumberValue(range[1]))))));
};
export default ColorMap;
